import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/cost-of-living-calculator/CostOfLivingContent.tsx");
